import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
//import doctorAnim from "../assets/doctor.json";
import medicineAnim from "../assets/medicine.json";
import deliveryAnim from "../assets/delivery.json";
import discountAnim from "../assets/discount.json";
import surgicalAnim from "../assets/surgical.json";
import wellnessAnim from "../assets/wellness.json";



export default function IntroPage() {
  const navigate = useNavigate();
const touchStartX = useRef(0);
  const [current, setCurrent] = useState(0);


  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const role = localStorage.getItem("userRole");

    if (!token || !role) return;

    const dashboardRoutes = {
      superadmin: "/super-admin",
      admin: "/admin",
      patient: "/customer-dashboard",
      pharmacist: "/internal-pharmacist",
      delivery: "/delivery",
      hospitalpharmacist: "/hospital-pharmacist",
    };

    const dashboard = dashboardRoutes[role];

    if (dashboard) {
      navigate(dashboard, { replace: true });
    }
  }, [navigate]);


const slides = [
  {
    animation: medicineAnim,
    title: "Generic & Branded Medicines",
    desc: "Save more with quality generic medicines and trusted branded products.",
  },
  {
    animation: deliveryAnim,
    title: "Fast & Reliable Delivery",
    desc: "Track your orders and receive them quickly.",
  },
  {
    animation: discountAnim,
    title: "Save More on Every Order",
    desc: "Exclusive discounts on medicines and healthcare products.",
  },
  {
    animation: surgicalAnim,
    title: "Surgical & Healthcare Essentials",
    desc: "Medical devices and surgical products at your fingertips.",
  },
  {
    animation: wellnessAnim,
    title: "Hair, Skin & Wellness Care",
    desc: "Hair care, skin care and multivitamins in one place.",
  },
];


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  //let touchStartX = 0;

const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};

const handleTouchEnd = (e) => {
  const touchEndX = e.changedTouches[0].clientX;

  if (
    touchStartX.current - touchEndX > 50 &&
    current < slides.length - 1
  ) {
    setCurrent((prev) => prev + 1);
  }

  if (
    touchEndX - touchStartX.current > 50 &&
    current > 0
  ) {
    setCurrent((prev) => prev - 1);
  }
};

  return (
    <div style={styles.container}>
      
      {/* CENTER LOGO */}
      <h1 style={styles.logo}>
  Pharma<span style={{ color: "#2a7ae4" }}>Help</span>
</h1>
<p style={styles.tagline}>
  Your Trusted Online Pharmacy
</p>

      {/* ANIMATION */}
      <div
        style={styles.content}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <Lottie
  animationData={slides[current].animation}
  style={{ height: 220 }}
/>

        {/* TEXT */}
        <div key={current}>
          <h2 style={styles.title}>{slides[current].title}</h2>
          <p style={styles.desc}>{slides[current].desc}</p>
        </div>

        {/* DOTS */}
        <div style={styles.dots}>
          {slides.map((_, i) => (
            <span
              key={i}
              style={{
                ...styles.dot,
                background: current === i ? "#2a7ae4" : "#444",
              }}
            />
          ))}
        </div>
      </div>

      {/* ONLY LOGIN BUTTON */}
      <button
        style={styles.loginBtn}
        onClick={() => {
          localStorage.setItem("seenIntro", "true");
          navigate("/public-customer");
        }}
      >
        Explore PharmaHelp →
      </button>
    </div>
  );
}


const styles = {
  container: {
    minHeight: "100vh",
    background: "#0b0f1a",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    padding: "20px",
    textAlign: "center",
  },

 

  content: {
    maxWidth: 400,
    width: "100%",
  },

  title: {
    fontSize: "clamp(20px, 5vw, 24px)",
    marginTop: 10,
    marginBottom: 10,
  },

  desc: {
    fontSize: "clamp(14px, 4vw, 16px)",
    color: "#aaa",
    padding: "0 10px",
  },

  dots: {
    display: "flex",
    justifyContent: "center",
    marginTop: 15,
    gap: 6,
  },
logo: {
  fontSize: "42px",
  fontWeight: "800",
  letterSpacing: "-1px",
  marginBottom: 20,
},
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
  },
tagline: {
  color: "#94a3b8",
  fontSize: "14px",
  marginTop: "-10px",
  marginBottom: "25px",
},
  loginBtn: {
    marginTop: 30,
    width: "90%",
    maxWidth: 350,
    padding: 14,
    background: "#2a7ae4",
    border: "none",
    borderRadius: 10,
    color: "#fff",
    fontSize: 16,
    cursor: "pointer",
  },
};